import { render, staticRenderFns } from "./MAM_risePrice.vue?vue&type=template&id=5a96981a&"
import script from "./MAM_risePrice.vue?vue&type=script&lang=js&"
export * from "./MAM_risePrice.vue?vue&type=script&lang=js&"
import style0 from "./MAM_risePrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports